<template>
  <div class="mobile-navigation col-12">
    <div class="mobile-navigation__toolbar row items-center justify-between no-wrap full-width">
      <CalculatorButton
        class="mobile-navigation__shortlist"
        label="View shortlist"
        :rounded="isCalculatorButtonRounded"
        icon-direction="right"
        has-chevron-icon
        tertiary-border
        :color="hasItemsInShortList ? 'tertiary' : undefined"
        :disabled="!hasItemsInShortList"
        @click="$emit('viewShortlist')"
      />
      <div class="row items-center no-wrap mobile-navigation__filters-actions">
        <CalculatorButton
          class="mobile-navigation__filters-pill text-white"
          color="secondary"
          :rounded="isCalculatorButtonRounded"
          :label="filtersLabel"
          @click="$emit('update:showRefineSearchModal', true)"
        />
        <CalculatorButton
          class="vehicle-page-header__lease-options-toggle"
          type="button"
          label=""
          :rounded="isCalculatorButtonRounded"
          :icon="optionsIcon"
          icon-direction="right"
          outline
          color="primary"
          aria-label="Open filters"
          @click="$emit('update:showRefineSearchModal', true)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { evaOptions2Outline } from '@quasar/extras/eva-icons';
import CalculatorButton from '../CalculatorButton';
import { countVehicleResultSearchFilters } from '../../../utils/calculator/countVehicleResultSearchFilters';

export default {
  name: 'MobileNavigation',
  components: {
    CalculatorButton
  },
  props: {
    showRefineSearchModal: {
      type: Boolean,
      default: false
    },
    searchOptions: {
      type: Object,
      default: () => ({})
    },
    hasItemsInShortList: {
      type: Boolean,
      default: false
    },
    isCalculatorButtonRounded: {
      type: Boolean,
      default: false
    },
    /** Length of `vehicleSearchConfig.make`; when ≤1 the Make hub row is hidden — badge omits that implicit make. */
    makeFacetOptionCount: {
      type: Number,
      default: undefined
    }
  },
  created() {
    this.optionsIcon = evaOptions2Outline;
  },
  computed: {
    filterCount() {
      return countVehicleResultSearchFilters(this.searchOptions, {
        makeFacetOptionCount: this.makeFacetOptionCount
      });
    },
    filtersLabel() {
      return `Filters ${this.filterCount}`;
    }
  }
};
</script>
